define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/heading/_base",
	"csi/html",
	"csi/types",
	"csi/xml",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"../SizeChart",
	"./Number"
], function(declare, lang, csi, def, csiHeading, html, types, xml, {SizeChartDimensionFormatType}, SizeChart, NumberRen) {

	var _htmlDiff = ' / <span class="diff">';
	var _htmlEndSpan = '</span>';
	var _readFormat = lang.hitch(types, types.getNumberRead);

	return declare(NumberRen, {
		html1: '<span class="increment">',

		/**
		 * @override
		 * enable drag-fill
		 */
		canCopy: function(ctxCopy, h) {
			return true;
		},

		/**
		 * Render size chart dimension Tolerance/ToleranceNegative value for cell
		 * @param {Context} ctx
		 * @param {Heading) h
		 * @param {DOMNode) refNode
		 */
		headingToHtml: function(ctx, h, refNode) {
			var view = ctx.view;
			if (view.bCompareShape || view.bCompareIncrements) {
				//C8-9088 : Size Chart Compare Shape: Extend to show differences in Tolerance attributes
				var curTol = this._getValue(ctx, h);
				// C8-9574 Product Group: Tolerance attributes display "Error" instead of value.
				// DimensionTable has this method, but if viewing tolerances
				// outside the context of compare shape for size charts, the
				// view is different so will get error.
				var shapeTol = ctx.view.getToleranceDifference ? ctx.view.getToleranceDifference(ctx.getNodeURL(), h.m_id) : null;

				// Display as different if current value is different from Shape's value
				if (shapeTol != null && (shapeTol != curTol)) {
					var node = ctx.getNode();
					var css = def.getCSS(h, this._getRenderCSS(ctx, h, refNode), node, ctx.cache, ctx);
					css += " csi-tolerance-value"; // Draw difference grayed
					html.setClass(refNode, css);

					var v = this._getFormattedValue(ctx, h, null, _readFormat);
					var s = this.html1 + v + "" + _htmlEndSpan;
					s += _htmlDiff + this._getFormattedValue(ctx, h, shapeTol, _readFormat) + _htmlEndSpan;
					refNode.innerHTML = s;

					// setup cell for editing
					csiHeading.markHeadingNode(refNode, h, ctx);
					if (this._canEditDimension(ctx, h)) {
						csiHeading.markHeadingEditable(refNode, h);
					}
					return;
				}
			}

			this.inherited(arguments);

			if (!this._canEditNumber(ctx, h)) {
				csiHeading.unmarkHeadingNode(refNode);
			}
		},

		/**
		 * @override
		 * If comparing shape, display the tooltip action only when the Tolerance/ToleranceNegative is different from the shape size chart dimension ones
		 */
		headingToTooltip: function(ctx, h, tooltip) {
			// C8-9574 Product Group: Tolerance attributes display "Error" instead of value.
			// DimensionTable has this method, but if viewing tolerances
			// outside the context of compare shape for size charts, the
			// view is different so will get error.
			var curTol = this._getValue(ctx, h);
			var shapeTol = ctx.view.getToleranceDifference ? ctx.view.getToleranceDifference(ctx.getNodeURL(), h.m_id) : null;

			if (curTol != shapeTol) {
				return this.inherited(arguments);
			}
		},

		/*
		 * calculate edit permission once rather than once per cell
		 * @param {Context} ctx
		 * @param {Heading) h
		 */
		_canEditNumber: function(ctx, h) {
			return !ctx.bPrint && !ctx.isReadOnly() && xml.nodeHasAccess(ctx.getNode(), h.getRight(), h.m_id);
		},


		/*
		 * calculate edit permission over SizeChartDimension once rather than once per cell
		 * @param {Context} ctx
		 * @param {Heading) h
		 */
		_canEditDimension: function(ctx, h) {
			return !ctx.bPrint && !ctx.isReadOnly() && xml.nodeHasRight(ctx.getNode(), h.getRight());
		},

		_getFactor: function(/*Context*/ctx) {
			// summary: if displaying tolerance as percentage, then do not use conversion factor
			return SizeChart.bPct ? null : this.inherited(arguments);
		},

		_getFormat: function(/*Context*/ctx, /*Heading*/h) {
			// summary: use configuration setting for format
			return this._isFraction(ctx) ? types.FORMAT_IN_FRACTION : SizeChart.formatTolDelta;
		},

		/**
		 * Return formatted value
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {Number} value
		 * @param {Function} func
		 */
		_getFormattedValue: function(ctx, h, value, func) {
			if (value == undefined) {
				value = this._getValue(ctx, h);
			}

			if (SizeChart.isNotInitialized(value)) {
				return csi.EMPTY_CHAR;
			}

			var format;

			if (this._isFraction(ctx)) {
				format = types.FORMAT_IN_FRACTION;
			} else if (ctx.view.sizeChartDimensionFormat == SizeChartDimensionFormatType.DEFAULT) {
				format = (!this.isIncrementDisplay(ctx)) ? SizeChart.formatAbs : SizeChart.formatInc;
			} else {
				format = ctx.view.sizeChartDimensionFormat;
			}

			return func(this._applyFactor(ctx, value), format);
		},

		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return CSS for current heading in context
			var css = this.inherited(arguments);

			if (SizeChart.isNotInitialized(this._getValue(ctx, h))) {
				if ((ctx.view.sizeChartHighlightBlank || ctx.view.sizeChartHighlightBlankTolerance) && !ctx.getNode().Blanks) {
					css += " PatternBlank";
				}
			}

			return css;
		},

		_isFraction: function(/*Context*/ctx) {
			// summary: do not use fractions if displaying tolerance as percentage
			return !SizeChart.bPct && this.inherited(arguments);
		}
	});
});
